import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Mounts on a transient element appended by `close_modal_window` (see
// FlashMessages::FlashRenderer). On connect, dismisses any currently-visible
// Bootstrap modal via the official Modal API, then removes itself.
//
// Replaces the older inline-<script> approach inside `<turbo-stream><template>`:
// that path depends on Turbo's script activation + the script-side click on
// `[data-bs-dismiss="modal"]` finding the right button + Bootstrap reacting to
// it. Real-world testing exposed cases where the modal stayed open even though
// the row-removal stream in the same response succeeded. Going through
// Modal.getInstance(...).hide() is direct and lets the existing
// `bs_modal_controller` `hidden.bs.modal` handler clean up the DOM, backdrop,
// and body classes the way it always has.
//
// A modal mounted by `bs-modal` is closed through that controller, which also
// handles a modal still fading in: Bootstrap ignores hide() during the show
// transition, and such a modal has no `.show` class yet, so neither the selector
// below nor a plain hide() would reach it.
export default class extends Controller {
  connect() {
    const mounted = new Set(document.querySelectorAll('.modal[data-controller~="bs-modal"]'))
    mounted.forEach((modalElement) => {
      this.application.getControllerForElementAndIdentifier(modalElement, "bs-modal")?.close()
    })

    document.querySelectorAll(".modal.show").forEach((modalElement) => {
      if (mounted.has(modalElement)) return

      const instance = Modal.getInstance(modalElement) || new Modal(modalElement)
      instance.hide()
    })
    this.element.remove()
  }
}
